<template>
  <tr class="man-wrap" :class="{ rows__single: type === 'rows' }">
    <div class="cards__single" v-if="type === 'cards'">
      <router-link :to="'/workers/' + id" class="link-not-like photo photo-human">
        <img :src="$media_url + (photo ? photo : 'users/noavatar.png')" alt=""/>
      </router-link>
      <div class="cards__main-info">
        <h2>
          <router-link class="link-not-like" :to="'/workers/' + id">{{
              options.array[0].value
            }}
          </router-link>
        </h2>
        <span class="main-info__description">
          {{
            options.array[1].value[$vuetify.lang.current] ? options.array[1].value[$vuetify.lang.current] : options.array[1].value['eng'] ? options.array[1].value['eng'] : options.array[1].value['fin']
          }}
        </span>
      </div>
      <div class="cards__buttons">
        <button class="btn-icon btn-action" @click="printProfile">
          <picture>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.80036 13.2004C7.64123 13.2004 7.48862 13.2636 7.3761 13.3761C7.26358 13.4886 7.20036 13.6413 7.20036 13.8004V16.2004C7.20036 16.3595 7.26358 16.5121 7.3761 16.6247C7.48862 16.7372 7.64123 16.8004 7.80036 16.8004C7.95949 16.8004 8.1121 16.7372 8.22463 16.6247C8.33715 16.5121 8.40036 16.3595 8.40036 16.2004V16.0012H8.79996C9.17137 16.0012 9.52757 15.8536 9.7902 15.591C10.0528 15.3284 10.2004 14.9722 10.2004 14.6008C10.2004 14.2294 10.0528 13.8732 9.7902 13.6106C9.52757 13.3479 9.17137 13.2004 8.79996 13.2004H7.80036ZM8.79996 14.8012H8.40036V14.4004H8.79996C8.85311 14.4004 8.90409 14.4215 8.94167 14.4591C8.97925 14.4967 9.00036 14.5476 9.00036 14.6008C9.00036 14.6539 8.97925 14.7049 8.94167 14.7425C8.90409 14.7801 8.85311 14.8012 8.79996 14.8012Z"
                fill="#2C1521"/>
              <path
                d="M14.4004 13.8004C14.4004 13.6413 14.4636 13.4886 14.5761 13.3761C14.6886 13.2636 14.8412 13.2004 15.0004 13.2004H16.2004C16.3595 13.2004 16.5121 13.2636 16.6246 13.3761C16.7371 13.4886 16.8004 13.6413 16.8004 13.8004C16.8004 13.9595 16.7371 14.1121 16.6246 14.2247C16.5121 14.3372 16.3595 14.4004 16.2004 14.4004H15.6004V14.8024H16.2004C16.3595 14.8024 16.5121 14.8656 16.6246 14.9781C16.7371 15.0906 16.8004 15.2433 16.8004 15.4024C16.8004 15.5615 16.7371 15.7141 16.6246 15.8267C16.5121 15.9392 16.3595 16.0024 16.2004 16.0024H15.6004V16.1992C15.6005 16.278 15.5852 16.356 15.5552 16.4289C15.5251 16.5017 15.4811 16.568 15.4255 16.6238C15.3132 16.7366 15.1607 16.8001 15.0016 16.8004C14.8424 16.8007 14.6897 16.7378 14.5769 16.6255C14.4642 16.5132 14.4007 16.3607 14.4004 16.2016V13.8004Z"
                fill="#2C1521"/>
              <path
                d="M11.3992 13.2004C11.24 13.2004 11.0874 13.2636 10.9749 13.3761C10.8624 13.4886 10.7992 13.6413 10.7992 13.8004V16.2004C10.7992 16.3595 10.8624 16.5121 10.9749 16.6247C11.0874 16.7372 11.24 16.8004 11.3992 16.8004H12.0004C12.4778 16.8004 12.9356 16.6107 13.2732 16.2732C13.6107 15.9356 13.8004 15.4778 13.8004 15.0004C13.8004 14.523 13.6107 14.0652 13.2732 13.7276C12.9356 13.39 12.4778 13.2004 12.0004 13.2004H11.3992ZM11.9992 15.6004V14.4004H12.0004C12.1595 14.4004 12.3121 14.4636 12.4246 14.5761C12.5371 14.6886 12.6004 14.8413 12.6004 15.0004C12.6004 15.1595 12.5371 15.3121 12.4246 15.4247C12.3121 15.5372 12.1595 15.6004 12.0004 15.6004H11.9992Z"
                fill="#2C1521"/>
              <path
                d="M4.80036 4.80039C4.80036 4.16387 5.05322 3.55342 5.50331 3.10333C5.95339 2.65325 6.56384 2.40039 7.20036 2.40039H12.7036C13.1808 2.40081 13.6383 2.59073 13.9756 2.92839L18.6736 7.62519C19.0112 7.96243 19.2011 8.41996 19.2016 8.89719V10.8988C19.552 11.0233 19.8553 11.2532 20.0698 11.557C20.2842 11.8609 20.3993 12.2237 20.3992 12.5956V17.3992C20.3992 17.7712 20.2839 18.1341 20.0693 18.438C19.8546 18.7419 19.551 18.9717 19.2004 19.096V19.2004C19.2004 19.8369 18.9475 20.4474 18.4974 20.8974C18.0473 21.3475 17.4369 21.6004 16.8004 21.6004H7.20036C6.56384 21.6004 5.95339 21.3475 5.50331 20.8974C5.05322 20.4474 4.80036 19.8369 4.80036 19.2004V19.096C4.44969 18.9717 4.14613 18.7419 3.93145 18.438C3.71678 18.1341 3.60153 17.7712 3.60156 17.3992V12.5956C3.60162 12.2234 3.71704 11.8604 3.93194 11.5565C4.14685 11.2526 4.45066 11.0229 4.80156 10.8988V4.80039H4.80036ZM18.0004 9.60039H13.8004C13.323 9.60039 12.8651 9.41075 12.5276 9.07318C12.19 8.73562 12.0004 8.27778 12.0004 7.80039V3.60039H7.20036C6.8821 3.60039 6.57688 3.72682 6.35183 3.95186C6.12679 4.17691 6.00036 4.48213 6.00036 4.80039V10.7956H18.0004V9.60039ZM6.00036 19.1992C6.00021 19.3569 6.03113 19.513 6.09136 19.6588C6.1516 19.8045 6.23996 19.9369 6.35141 20.0485C6.46286 20.16 6.5952 20.2486 6.74087 20.3089C6.88653 20.3693 7.04268 20.4004 7.20036 20.4004H16.8004C16.9581 20.4004 17.1142 20.3693 17.2599 20.3089C17.4055 20.2486 17.5379 20.16 17.6493 20.0485C17.7608 19.9369 17.8491 19.8045 17.9094 19.6588C17.9696 19.513 18.0005 19.3569 18.0004 19.1992H6.00036ZM13.2004 3.84879V7.80039C13.2004 7.95952 13.2636 8.11213 13.3761 8.22465C13.4886 8.33718 13.6412 8.40039 13.8004 8.40039H17.752L13.2004 3.84879ZM5.40156 11.9956C5.24243 11.9956 5.08982 12.0588 4.9773 12.1713C4.86478 12.2838 4.80156 12.4365 4.80156 12.5956V17.3992C4.80156 17.5583 4.86478 17.7109 4.9773 17.8235C5.08982 17.936 5.24243 17.9992 5.40156 17.9992H18.6004C18.7595 17.9992 18.9121 17.936 19.0246 17.8235C19.1372 17.7109 19.2004 17.5583 19.2004 17.3992V12.5956C19.2004 12.4365 19.1372 12.2838 19.0246 12.1713C18.9121 12.0588 18.7595 11.9956 18.6004 11.9956H5.40036H5.40156Z"
                fill="#2C1521"/>
            </svg>
          </picture>
        </button>
        <button v-if="permissions.edit.indexOf('Работники') !== -1" class="btn-icon btn-action"
                @click="confirm_archive_modal=true">
          <picture>
            <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc" focusable="false"
                 aria-hidden="true" viewBox="0 0 24 24" data-testid="ArchiveOutlinedIcon">
              <path
                d="m20.54 5.23-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.81.97H5.44l.8-.97zM5 19V8h14v11H5zm8.45-9h-2.9v3H8l4 4 4-4h-2.55z"></path>
            </svg>
          </picture>
        </button>
        <button v-if="permissions.edit.indexOf('Работники') !== -1" class="btn-icon btn-action"
                @click="confirm_dismiss_modal=true">
          <picture>
            <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PersonOffOutlinedIcon">
              <path
                d="m20 17.17-3.37-3.38c.64.22 1.23.48 1.77.76.97.51 1.58 1.52 1.6 2.62m1.19 4.02-1.41 1.41-2.61-2.6H4v-2.78c0-1.12.61-2.15 1.61-2.66 1.29-.66 2.87-1.22 4.67-1.45L1.39 4.22 2.8 2.81zM15.17 18l-3-3H12c-2.37 0-4.29.73-5.48 1.34-.32.16-.52.5-.52.88V18zM12 6c1.1 0 2 .9 2 2 0 .86-.54 1.59-1.3 1.87l1.48 1.48C15.28 10.64 16 9.4 16 8c0-2.21-1.79-4-4-4-1.4 0-2.64.72-3.35 1.82l1.48 1.48C10.41 6.54 11.14 6 12 6"></path>
            </svg>
          </picture>
        </button>
        <button v-if="permissions.edit.indexOf('Работники') != -1 && active === 'archived'" class="btn-icon btn-action"
                @click="confirm_open(id)">
          <picture>
            <img src="../../assets/img/delete-icon.png" alt="delete"/>
          </picture>
        </button>
      </div>
      <ul class="cards__info">
        <li v-for="(option, idx) in options.array.slice(2, 7)" :key="idx">
          <span v-html="option.icon"></span>
          <span v-html="option.value"></span>
        </li>
      </ul>
    </div>
    <template v-if="type == 'rows'">
      <template v-for="(header) in headers">
        <template v-if="$parent.showHeaders[header.key]">
          <td v-if="header.key == 'fullname'" :key="header.key">
            <router-link :to="'/workers/' + id" class="link-not-like flex">
              <div class="avatar">
                <img :src="$media_url + (photo ? photo : 'users/noavatar.png')" alt=""/>
              </div>
              {{ options[header.key] }}
            </router-link>
          </td>
          <td v-else-if="header.key=='position'" :key="header.key">
            {{
              options[header.key][$vuetify.lang.current] ? options[header.key][$vuetify.lang.current] : options[header.key]['eng'] ? options[header.key]['eng'] : options[header.key]['fin']
            }}
          </td>
          <td v-else :key="header.key" v-html="options[header.key] "></td>
        </template>
      </template>
      <td class="rows__dot-menu">
        <v-menu bottom right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
              <svg v-bind="attrs" v-on="on" width="20" height="5" viewBox="0 0 20 5" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
              </svg>
            </v-btn>
          </template>
          <div class="rows__dot-menu-content">
            <div class="btn-wrap" @click="printProfile">
              {{ $vuetify.lang.t('$vuetify.printDoc') }}
              <button class="btn-icon btn-action">
                <picture>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.80036 13.2004C7.64123 13.2004 7.48862 13.2636 7.3761 13.3761C7.26358 13.4886 7.20036 13.6413 7.20036 13.8004V16.2004C7.20036 16.3595 7.26358 16.5121 7.3761 16.6247C7.48862 16.7372 7.64123 16.8004 7.80036 16.8004C7.95949 16.8004 8.1121 16.7372 8.22463 16.6247C8.33715 16.5121 8.40036 16.3595 8.40036 16.2004V16.0012H8.79996C9.17137 16.0012 9.52757 15.8536 9.7902 15.591C10.0528 15.3284 10.2004 14.9722 10.2004 14.6008C10.2004 14.2294 10.0528 13.8732 9.7902 13.6106C9.52757 13.3479 9.17137 13.2004 8.79996 13.2004H7.80036ZM8.79996 14.8012H8.40036V14.4004H8.79996C8.85311 14.4004 8.90409 14.4215 8.94167 14.4591C8.97925 14.4967 9.00036 14.5476 9.00036 14.6008C9.00036 14.6539 8.97925 14.7049 8.94167 14.7425C8.90409 14.7801 8.85311 14.8012 8.79996 14.8012Z"
                      fill="#2C1521"/>
                    <path
                      d="M14.4004 13.8004C14.4004 13.6413 14.4636 13.4886 14.5761 13.3761C14.6886 13.2636 14.8412 13.2004 15.0004 13.2004H16.2004C16.3595 13.2004 16.5121 13.2636 16.6246 13.3761C16.7371 13.4886 16.8004 13.6413 16.8004 13.8004C16.8004 13.9595 16.7371 14.1121 16.6246 14.2247C16.5121 14.3372 16.3595 14.4004 16.2004 14.4004H15.6004V14.8024H16.2004C16.3595 14.8024 16.5121 14.8656 16.6246 14.9781C16.7371 15.0906 16.8004 15.2433 16.8004 15.4024C16.8004 15.5615 16.7371 15.7141 16.6246 15.8267C16.5121 15.9392 16.3595 16.0024 16.2004 16.0024H15.6004V16.1992C15.6005 16.278 15.5852 16.356 15.5552 16.4289C15.5251 16.5017 15.4811 16.568 15.4255 16.6238C15.3132 16.7366 15.1607 16.8001 15.0016 16.8004C14.8424 16.8007 14.6897 16.7378 14.5769 16.6255C14.4642 16.5132 14.4007 16.3607 14.4004 16.2016V13.8004Z"
                      fill="#2C1521"/>
                    <path
                      d="M11.3992 13.2004C11.24 13.2004 11.0874 13.2636 10.9749 13.3761C10.8624 13.4886 10.7992 13.6413 10.7992 13.8004V16.2004C10.7992 16.3595 10.8624 16.5121 10.9749 16.6247C11.0874 16.7372 11.24 16.8004 11.3992 16.8004H12.0004C12.4778 16.8004 12.9356 16.6107 13.2732 16.2732C13.6107 15.9356 13.8004 15.4778 13.8004 15.0004C13.8004 14.523 13.6107 14.0652 13.2732 13.7276C12.9356 13.39 12.4778 13.2004 12.0004 13.2004H11.3992ZM11.9992 15.6004V14.4004H12.0004C12.1595 14.4004 12.3121 14.4636 12.4246 14.5761C12.5371 14.6886 12.6004 14.8413 12.6004 15.0004C12.6004 15.1595 12.5371 15.3121 12.4246 15.4247C12.3121 15.5372 12.1595 15.6004 12.0004 15.6004H11.9992Z"
                      fill="#2C1521"/>
                    <path
                      d="M4.80036 4.80039C4.80036 4.16387 5.05322 3.55342 5.50331 3.10333C5.95339 2.65325 6.56384 2.40039 7.20036 2.40039H12.7036C13.1808 2.40081 13.6383 2.59073 13.9756 2.92839L18.6736 7.62519C19.0112 7.96243 19.2011 8.41996 19.2016 8.89719V10.8988C19.552 11.0233 19.8553 11.2532 20.0698 11.557C20.2842 11.8609 20.3993 12.2237 20.3992 12.5956V17.3992C20.3992 17.7712 20.2839 18.1341 20.0693 18.438C19.8546 18.7419 19.551 18.9717 19.2004 19.096V19.2004C19.2004 19.8369 18.9475 20.4474 18.4974 20.8974C18.0473 21.3475 17.4369 21.6004 16.8004 21.6004H7.20036C6.56384 21.6004 5.95339 21.3475 5.50331 20.8974C5.05322 20.4474 4.80036 19.8369 4.80036 19.2004V19.096C4.44969 18.9717 4.14613 18.7419 3.93145 18.438C3.71678 18.1341 3.60153 17.7712 3.60156 17.3992V12.5956C3.60162 12.2234 3.71704 11.8604 3.93194 11.5565C4.14685 11.2526 4.45066 11.0229 4.80156 10.8988V4.80039H4.80036ZM18.0004 9.60039H13.8004C13.323 9.60039 12.8651 9.41075 12.5276 9.07318C12.19 8.73562 12.0004 8.27778 12.0004 7.80039V3.60039H7.20036C6.8821 3.60039 6.57688 3.72682 6.35183 3.95186C6.12679 4.17691 6.00036 4.48213 6.00036 4.80039V10.7956H18.0004V9.60039ZM6.00036 19.1992C6.00021 19.3569 6.03113 19.513 6.09136 19.6588C6.1516 19.8045 6.23996 19.9369 6.35141 20.0485C6.46286 20.16 6.5952 20.2486 6.74087 20.3089C6.88653 20.3693 7.04268 20.4004 7.20036 20.4004H16.8004C16.9581 20.4004 17.1142 20.3693 17.2599 20.3089C17.4055 20.2486 17.5379 20.16 17.6493 20.0485C17.7608 19.9369 17.8491 19.8045 17.9094 19.6588C17.9696 19.513 18.0005 19.3569 18.0004 19.1992H6.00036ZM13.2004 3.84879V7.80039C13.2004 7.95952 13.2636 8.11213 13.3761 8.22465C13.4886 8.33718 13.6412 8.40039 13.8004 8.40039H17.752L13.2004 3.84879ZM5.40156 11.9956C5.24243 11.9956 5.08982 12.0588 4.9773 12.1713C4.86478 12.2838 4.80156 12.4365 4.80156 12.5956V17.3992C4.80156 17.5583 4.86478 17.7109 4.9773 17.8235C5.08982 17.936 5.24243 17.9992 5.40156 17.9992H18.6004C18.7595 17.9992 18.9121 17.936 19.0246 17.8235C19.1372 17.7109 19.2004 17.5583 19.2004 17.3992V12.5956C19.2004 12.4365 19.1372 12.2838 19.0246 12.1713C18.9121 12.0588 18.7595 11.9956 18.6004 11.9956H5.40036H5.40156Z"
                      fill="#2C1521"/>
                  </svg>
                </picture>
              </button>
            </div>
            <div v-if="permissions.edit.indexOf('Работники') !== -1" class="btn-wrap"
                 @click="confirm_archive_modal=true">
              <span v-if="active != 'archive'">{{ $vuetify.lang.t('$vuetify.toArchive') }}</span>
              <span v-else>{{ $vuetify.lang.t('$vuetify.deleteArchive') }}</span>
              <button class="btn-icon btn-action">
                <picture>
                  <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc" focusable="false"
                       aria-hidden="true" viewBox="0 0 24 24" data-testid="ArchiveOutlinedIcon">
                    <path
                      d="m20.54 5.23-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.81.97H5.44l.8-.97zM5 19V8h14v11H5zm8.45-9h-2.9v3H8l4 4 4-4h-2.55z"></path>
                  </svg>
                </picture>
              </button>
            </div>
            <div v-if="permissions.edit.indexOf('Работники') !== -1" class="btn-wrap"
                 @click="confirm_dismiss_modal=true">
              <span v-if="active != 'dismissed'">{{ $vuetify.lang.t('$vuetify.dismiss') }}</span>
              <span v-else>{{ $vuetify.lang.t('$vuetify.hire') }}</span>
              <button class="btn-icon btn-action">
                <picture>
                  <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PersonOffOutlinedIcon">
                    <path
                      d="m20 17.17-3.37-3.38c.64.22 1.23.48 1.77.76.97.51 1.58 1.52 1.6 2.62m1.19 4.02-1.41 1.41-2.61-2.6H4v-2.78c0-1.12.61-2.15 1.61-2.66 1.29-.66 2.87-1.22 4.67-1.45L1.39 4.22 2.8 2.81zM15.17 18l-3-3H12c-2.37 0-4.29.73-5.48 1.34-.32.16-.52.5-.52.88V18zM12 6c1.1 0 2 .9 2 2 0 .86-.54 1.59-1.3 1.87l1.48 1.48C15.28 10.64 16 9.4 16 8c0-2.21-1.79-4-4-4-1.4 0-2.64.72-3.35 1.82l1.48 1.48C10.41 6.54 11.14 6 12 6"></path>
                  </svg>
                </picture>
              </button>
            </div>
            <div v-if="permissions.edit.indexOf('Работники') !== -1  && active != 'working'" class="btn-wrap"
                 @click="confirm_open(id)">
              {{ $vuetify.lang.t('$vuetify.delete') }}
              <button class="btn-icon btn-action">
                <delete-icon/>
              </button>
            </div>
          </div>
        </v-menu>
      </td>
    </template>
    <ConfirmModal v-model="confirm_modal" @confirm="tmp_delete">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <ConfirmArchiveModal v-model="confirm_archive_modal" @confirm="tmp_archive" :active="active">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmArchiveModal>
    <ConfirmModal v-model="confirm_dismiss_modal" @confirm="tmp_dismiss">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
  </tr>
</template>
<script>
import ConfirmModal from "@/components/confirmModal.vue";
import DeleteIcon from "@/components/icons/DeleteIcon";
import ConfirmArchiveModal from "@/components/ConfirmArchiveModal";
import {mapGetters} from "vuex";

export default {
  name: "man-card",

  components: {
    ConfirmArchiveModal,
    DeleteIcon,
    ConfirmModal,
  },

  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    checked: Boolean,
    type: String,
    options: Object,
    headers: Array,
    photo: [String, undefined],
    id: Number,
    email: String,
    active: Boolean
  },

  data: function () {
    return {
      the_checked: this.checked,
      tmp: false,

      confirm_modal: false,
      confirm_archive_modal: false,
      confirm_dismiss_modal: false,
      tmp_to_delete: "",

      alertMsg: "",
      alertError: false,
    };
  },

  methods: {

    printProfile() {
      let path = ''
      this.$axios({
        url: this.$hostname + "time-tracking/print-profiles/" + this.id,
        method: "GET",
        async: false,
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        path = response.data.data.path
        if (path !== '' && path != undefined) {
          const axios = require('axios')
          axios({
            url: this.$hostname + path,
            method: 'GET',
            responseType: 'blob',
          }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', path.substr(path.lastIndexOf('/') + 1));
            document.body.appendChild(fileLink);

            fileLink.click();
          })
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    confirm_open(id) {
      this.confirm_modal = true;
      this.tmp_to_delete = id;
    },

    confirm_close() {
      this.confirm_modal = false;
      this.tmp_to_delete = "";
    },

    tmp_delete() {
      let email = this.email

      this.$axios
        .delete(this.$hostname + "time-tracking/user", {
          data: {
            email: email,
          },
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.alertMsg = "Пользователь удален";
          this.confirm_modal = false;
          this.$destroy();

          this.$el.parentNode.removeChild(this.$el);
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },

    tmp_archive() {
      this.$axios({
        url: this.$hostname + "time-tracking/organization/workers",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.id,
          status: this.active === 'archived' ? 'working' : 'archived',
        },
      }).then(() => {
        this.confirm_archive_modal = false
        this.$emit('archive')
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
      })
    },
    tmp_dismiss() {
      this.$axios({
        url: this.$hostname + "time-tracking/organization/workers",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.id,
          status: this.active === 'dismissed' ? 'working' : 'dismissed',
        },
      }).then(() => {
        this.confirm_dismiss_modal = false
        this.$emit('archive')
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
      })
    },
  },

  computed: {
    ...mapGetters(['permissions'])
  }
};
</script>
